import styled from "styled-components";

export const PostsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1280px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: ${({ theme }) => `calc(${theme.sizes.campaignCreation.navigationHeight} + 20px)`};
  padding-left: 24px;
  padding-right: 24px;
  gap: 20px;
`;

export const CampaignCreatePostEditorWrapper = styled.div`
  max-width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 20px;
`;

export const CampaignCreateRightPanelWrapper = styled.div`
  width: 305px;
`;

export const CampaignCreateSidebarChannelsWrapper = styled.div`
  width: 305px;
  text-align: left;
`;

export const StartingDateWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 10px;
`;

export const StartingDatePanel = styled.div`
  background: #ffffff;
  height: 100%;
  border-radius: 8px;
  padding: 8px 8px 8px 16px;
  border: 1px solid #f1f0f5;
  box-shadow: 0px 8px 16px 0px #00000014;
  width: 538px;
  position: relative;
`;

export const PreviewModeSwitchWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
  height: 38px;
`;

export const ActionButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 200px;
  font-family: Rubik;
  font-size: 14px;
  color: #1e1f46;
  width: 180px;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 6px;
  padding: 10px 10px;
  background-color: transparent;
  border-radius: 4px;
  border: none;
  transition: all 0.2s;
  cursor: pointer;

  div {
    margin-top: 1px;
  }
  &:hover {
    background-color: #1e1f4610;
  }
  &:disabled {
    color: #a2a7b3;
    cursor: not-allowed;
  }
`;

export const PrintViewWrapper = styled.div``;

export const PreviewsWrapper = styled.div`
  & > ${PrintViewWrapper} {
    @media screen {
      display: none;
    }
  }
  .statingDate-exit {
    max-height: 200px;
  }
  .statingDate-exit-active {
    max-height: 0;
    margin-top: 0;
    overflow: hidden;
    transition: all 300ms;
  }
`;

export const EmptyDiv = styled.div`
  min-width: 50px;
  content: "";
`;
